declare let M: any


export class ArticleContent { 
    public static init(){
        const targetNode = document.getElementsByTagName('body');
    
        const config = { 
            attributes: true, 
            childList: true,
            subtree: true 
        };
        
        const callback = function(mutationsList, observer) {
            for(let mutation of mutationsList) {

                if(mutation.target.classList.contains("litebox-text")) {
                    observer.disconnect();
                    ArticleContent.downloadButton(observer, targetNode[0], config);
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode[0], config);
    }

    public static downloadButton(observer : MutationObserver, target : Element, config) {
        ArticleContent.getImage();
        let list = document.getElementsByClassName("litebox-text");
        let newTag = document.createElement("div");
        newTag.id = "customDownloadButton";
        
        let newATag = document.createElement('a');
        newATag.setAttribute('href', ArticleContent.getImage());
        newATag.setAttribute('download', "");
        
        var textNode = document.createTextNode("Download");

        newATag.appendChild(textNode);
        newTag.appendChild(newATag);

        let contains = ArticleContent.isAdded();
    
        if(contains === false) {
            list[0].appendChild(newTag);
        }

        observer.observe(target, config);
    }

    public static isAdded(){
        let contains = document.getElementById('customDownloadButton');
        if(contains != null) {
            return true;
        } else {
            return false;
        }
        
    } 

    public static getImage() {
        let images = document.getElementsByClassName('litebox-content');
        return images[0].getAttribute('src');
    
        // return imageUrl;
    }
}